import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { AuthService } from 'src/app/providers/auth/auth.service';

@Component({
  selector: 'app-alumni-queries',
  templateUrl: './alumni-queries.component.html',
  styleUrls: ['./alumni-queries.component.scss'],
})
export class AlumniQueriesComponent implements OnInit {
  public empStatus = localStorage.getItem('emp_status');
  vewCmt = {
    a: true,
    b: false,
  };
  // constructor(private location: Location){

  // }
  empId: any = '';
  result: any = '';
  ipAddress: any = '';
  constructor(
    private router: Router,
    private authService: AuthService,
    private notifyService: NotificationService,
    private location: Location
  ) {
    console.log('jobs ye', document.referrer);
    let auth: any = localStorage.getItem('auth-token');
    auth = auth.split('-');
    // console.log(auth[1] + state.url);
    this.empId = auth[1].trim();
  }

  ngOnInit(): void {}

  changeEvent(ev): void {
    this.vewCmt[ev] = true;
    if (ev == 'a') {
      this.vewCmt = {
        a: true,
        b: false,
      };
    } else {
      this.vewCmt = {
        a: false,
        b: true,
      };
    }
  }
  back(): void {
    this.location.back();
  }
  logout(): void {
    const params = {
      ip: this.ipAddress,
      source: 'web',
    };
    console.log('pp', params);
    const popUp = localStorage.getItem('popUp');
    const date = localStorage.getItem('date');
    const usrId = localStorage.getItem('usrId');
    const ballon = localStorage.getItem('showBallon');
    const evntDate = localStorage.getItem('eventDate');

    this.authService.logOutFromJobs(params).subscribe(
      (res) => {
        this.result = res;
        // if (this.result.status) {
        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        this.router.navigate(['/']);
        this.notifyService.showSuccess(this.result.msg, 'Success');
        // }
      },
      (err) => {
        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        this.router.navigate(['/']);
        this.notifyService.showSuccess(this.result.msg, 'Success');
      }
    );
  }

  onFileChange(event): void {}
}
